import { RoutersType } from "../type/routes";
import sideBarTitle from "../assets/data/TkSideBarProperty";
import SCRW010001 from "../pages/SCRW010001";
import SCRW110001 from "../pages/SCRW110001";
import SCRW030001 from "../pages/SCRW030001";
import SCRW040002 from "../pages/SCRW040002";
import SCRW120001 from "../pages/SCRW120001";
import SCRW110003 from "../pages/SCRW110003";
import SCRW110005 from "../pages/SCRW110005";
import SCRW080001 from "../pages/SCRW080001";
import SCRW080002 from "../pages/SCRW080002";
import SCRW080003 from "../pages/SCRW080003";
import SCRW080004 from "../pages/SCRW080004";
import SCRW080005 from "../pages/SCRW080005";
import SCRW070008 from "../pages/SCRW070008";
import SCRW160001 from "../pages/SCRW160001";
import SCRW160002 from "../pages/SCRW160002";
import SCRW160003 from "../pages/SCRW160003";
import SCRW160004 from "../pages/SCRW160004";
import SCRW160005 from "../pages/SCRW160005";
import SCRW160006 from "../pages/SCRW160006";
import SCRW160007 from "../pages/SCRW160007";
import SCRW160009 from "../pages/SCRW160009";
import SCRW160010 from "../pages/SCRW160010";
import SCRW160011 from "../pages/SCRW160011";
import SCRW210001 from "../pages/SCRW210001";
import SCRW170001 from "../pages/SCRW170001";
import SCRW100001 from "../pages/SCRW100001";
import SCRW100003 from "../pages/SCRW100003";
import SCRW130002 from "../pages/SCRW130002";
import SCRW130003 from "../pages/SCRW130003";
import SCRW150001 from "../pages/SCRW150001";
import SCRW140001 from "../pages/SCRW140001";
import SCRW410002 from "../pages/SCRW410002";
import SCRW410030 from "../pages/SCRW410030";
import SCRW410006 from "../pages/SCRW410006";
import SCRW410004 from "../pages/SCRW410004";
import SCRW050006 from "../pages/SCRW050006";
import SCRW050007 from "../pages/SCRW050007";
import SCRW050008 from "../pages/SCRW050008";
import SCRW050003 from "../pages/SCRW050003";
import SCRW050009 from "../pages/SCRW050009";
import SCRW050001 from "../pages/SCRW050001";
import SCRW050004 from "../pages/SCRW050004";
import SCRW410001 from "../pages/SCRW410001";
import SCRW060003 from "../pages/SCRW060003";
import SCRW060004 from "../pages/SCRW060004";
import SCRW060005 from "../pages/SCRW060005";
import SCRW060101 from "../pages/SCRW060101";
import SCRW060102 from "../pages/SCRW060102";
import SCRW110002 from "../pages/SCRW110002";
import SCRW410005 from "../pages/SCRW410005";
import SCRW120002 from "../pages/SCRW120002";
import SCRW070005 from "../pages/SCRW070005";
import SCRW210002 from "../pages/SCRW210002";
import SCRW140002 from "../pages/SCRW140002";
import SCRW140003 from "../pages/SCRW140003";
import SCRW070012 from "../pages/SCRW070012";
import SCRW100005 from "../pages/SCRW100005";
import SCRW020001 from "../pages/SCRW020001";
import SCRW070004 from "../pages/SCRW070004";
import SCRW110007 from "../pages/SCRW110007";
import SCRW070007 from "../pages/SCRW070007";
import SCRW040001 from "../pages/SCRW040001";
import SCRW050002 from "../pages/SCRW050002";
import SCRW100002 from "../pages/SCRW100002";
import SCRW130001 from "../pages/SCRW130001";
import SCRW110006 from "../pages/SCRW110006";
import SCRW110004 from "../pages/SCRW110004";
import SCRW070001 from "../pages/SCRW070001";
import SCRW070002 from "../pages/SCRW070002";
import SCRW070003 from "../pages/SCRW070003";
import SCRC080006 from "../pages/SCRC080006";
import SCRW120004 from "../pages/SCRW120004";
import SCRW120005 from "../pages/SCRW120005";
import SCRW070010 from "../pages/SCRW070010";
import SCRW070011 from "../pages/SCRW070011";
import SCRC010003 from "../pages/SCRC010003";

/**
 * アプリケーションのルートオブジェクトの配列です。
 * @typedef {Object} RoutersType
 * @property {string} name - ルートの名前。
 * @property {string} path - ルートのパス。
 * @property {React.ComponentType} component - ルートにレンダリングするコンポーネント。
 */
const routes: RoutersType[] = [
  /**
   * 機構職員ホームのルート情報
   */
  {
    name: "各種契約者情報検索",
    path: "/SCRW120001",
    component: SCRW120001,
    meta: {
      title: "各種契約者情報検索",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.Inquiry,
      contextName: "job_114",
      setBusinessType: "JOB-114",
    },
  },
  {
    name: "機構職員ホーム",
    path: "/SCRW110001",
    component: SCRW110001,
    meta: {
      title: "機構職員ホーム",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.ApplicationAndNotification,
      sideBarContentAsTitle: "機構職員要処理対応",
    },
  },
  {
    name: "契約者未処理申請・届出等管理",
    path: "/SCRW110003",
    component: SCRW110003,
    meta: {
      title: "契約者未処理申請・届出等管理",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.ApplicationAndNotification,
      contextName: "searchForUnprocessed",
    },
  },
  {
    name: "機構職員代行入力",
    path: "/SCRW110005",
    component: SCRW110005,
    meta: {
      title: "機構職員代行入力",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.ProxyInputSupport,
    },
  },
  {
    name: "源泉徴収票の再発行依頼",
    path: "/SCRW110007",
    component: SCRW110007,
    meta: {
      title: "源泉徴収票の再発行依頼",
    },
  },
  {
    name: "施設照会",
    path: "/SCRW120004",
    component: SCRW120004,
    meta: {
      title: "施設照会",
      setBusinessType: "JOB-114",
    },
  },
  {
    name: "職員照会",
    path: "/SCRW120005",
    component: SCRW120005,
    meta: {
      title: "職員照会",
      setBusinessType: "JOB-114",
    },
  },
  {
    name: "契約者掛金届出状況一覧",
    path: "/SCRW080001",
    component: SCRW080001,
    meta: {
      title: "契約者掛金届出状況一覧",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.PremiumPaymentManagement,
    },
  },
  {
    name: "掛金届出状況詳細",
    path: "/SCRW080002",
    component: SCRW080002,
    meta: {
      title: "掛金届出状況詳細",
    },
  },
  {
    name: "掛金情報確認　施設一覧",
    path: "/SCRW080003",
    component: SCRW080003,
    meta: {
      title: "掛金情報確認　施設一覧",
      setBusinessType: "JOB-11",
      contextName: "groupApply,searchForHome",
    },
  },
  {
    name: "掛金納付延長申請　内容入力",
    path: "/SCRW080004",
    component: SCRW080004,
    meta: {
      title: "掛金納付延長申請　内容入力",
      contextName: "job_12,searchForHome",
    },
  },
  {
    name: "確定後掛金の変更登録",
    path: "/SCRW080005",
    component: SCRW080005,
    meta: {
      title: "確定後掛金の変更登録",
      setBusinessType: "JOB-49",
    },
  },
  {
    name: "退職者状況一覧",
    path: "/SCRW070008",
    component: SCRW070008,
    meta: {
      title: "退職者状況一覧",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.RetireeStatusManagement,
      contextName: "searchForRetirement",
    },
  },
  {
    name: "入金管理",
    path: "/SCRW160001",
    component: SCRW160001,
    meta: {
      title: "入金管理",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.PaymentProcessing,
      contextName: "paymentManagement",
    },
  },
  {
    name: "請求管理",
    path: "/SCRW160003",
    component: SCRW160003,
    meta: {
      title: "請求管理",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.PaymentProcessing,
    },
  },
  {
    name: "支払管理",
    path: "/SCRW160006",
    component: SCRW160006,
    meta: {
      title: "支払管理",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.PaymentProcessing,
      contextName: "paymentManagement",
    },
  },
  {
    name: "割増金一覧",
    path: "/SCRW160010",
    component: SCRW160010,
    meta: {
      title: "割増金一覧",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.PaymentProcessing,
      contextName: "paymentManagement",
    },
  },
  {
    name: "過納金一覧",
    path: "/SCRW160009",
    component: SCRW160009,
    meta: {
      title: "過納金一覧",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.PaymentProcessing,
      contextName: "paymentManagement,groupApply,searchForHome",
    },
  },
  {
    name: "補助金交付申請状況一覧",
    path: "/SCRW210001",
    component: SCRW210001,
    meta: {
      title: "補助金交付申請状況一覧",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.SubsidyManagement,
      setBusinessType: "JOB-82",
      contextName: "job_82",
    },
  },
  {
    name: "補助金交付申請（概算交付申請内容）",
    path: "/SCRW210002",
    component: SCRW210002,
    meta: {
      title: "補助金交付申請（概算交付申請内容）",
      sideBarContentTitle: sideBarTitle.SubsidyManagement,
      setBusinessType: "JOB-82",
      contextName: "job_82,searchForHome",
    },
  },
  {
    name: "各種データ出力",
    path: "/SCRW170001",
    component: SCRW170001,
    meta: {
      title: "データダウンロード",
      sideBarContentAsTitle: "各種データ出力",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.BusinessStatusManagement,
    },
  },
  {
    name: "契約者アカウント一覧",
    path: "/SCRW100001",
    component: SCRW100001,
    meta: {
      title: "契約者アカウント一覧",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.AccountManagement,
      setBusinessType: "JOB-100",
      contextName: "job_100",
    },
  },
  {
    name: "システム利用者ID・権限管理",
    path: "/SCRW100003",
    component: SCRW100003,
    meta: {
      title: "システム利用者ID・権限管理",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.AccountManagement,
      setBusinessType: "JOB-101",
      contextName: "job_101",
    },
  },
  {
    name: "通知メール",
    path: "/SCRW130001",
    component: SCRW130001,
    meta: {
      title: "通知メール",
    },
  },
  {
    name: "送信メール",
    path: "/SCRW130002",
    component: SCRW130002,
    meta: {
      title: "送信メール",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.Communication,
      setBusinessType: "JOB-122",
      contextName: "job_122",
    },
  },
  {
    name: "メール新規作成",
    path: "/SCRW130003",
    component: SCRW130003,
    meta: {
      title: "メール新規作成",
      setBusinessType: "job_122,searchForRetirement,searchForUnprocessed",
      contextName: "job_122,searchForRetirement,searchForUnprocessed",
    },
  },
  {
    name: "共済契約者との連絡掲示板",
    path: "/SCRW150001",
    component: SCRW150001,
    meta: {
      title: "共済契約者との連絡掲示板",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.Communication,
      setBusinessType: "JOB-45",
    },
  },
  {
    name: "テンプレート一覧",
    path: "/SCRW140001",
    component: SCRW140001,
    meta: {
      title: "テンプレート一覧",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.Others,
      setBusinessType: "JOB-122",
      contextName: "job_122",
    },
  },
  {
    name: "テンプレート新規登録",
    path: "/SCRW140002",
    component: SCRW140002,
    meta: {
      title: "テンプレート新規登録",
      setBusinessType: "JOB-122",
      contextName: "job_122",
    },
  },
  {
    name: "テンプレート詳細",
    path: "/SCRW140003",
    component: SCRW140003,
    meta: {
      title: "テンプレート詳細",
      setBusinessType: "JOB-122",
      contextName: "job_122",
    },
  },
  {
    name: "社会福施設職員等退職手当共済制度　共済契約のお申込み",
    path: "/SCRW030001",
    component: SCRW030001,
    meta: {
      title: "社会福施設職員等退職手当共済制度　共済契約のお申込み",
      contextName: "job_73,searchForHome",
    },
  },
  {
    name: "「俸給の調整額」新規申請",
    path: "/SCRW040002",
    component: SCRW040002,
    meta: {
      title: "「俸給の調整額」新規申請",
    },
  },
  {
    name: "退職手当金の請求手続き(振込状況の確認)",
    path: "/SCRW410030",
    component: SCRW410030,
    meta: {
      title: "退職手当金の請求手続き(振込状況の確認)",
      contextName: "job_37,job_38,searchForHome",
    },
  },
  {
    name: "退職手当金の請求手続き（請求者情報の登録）",
    path: "/SCRW410006",
    component: SCRW410006,
    meta: {
      title: "退職手当金の請求手続き（請求者情報の登録）",
      contextName: "job_39,job_70,job_114,groupApply,searchForHome",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（機構へ連絡）",
    path: "/SCRW410004",
    component: SCRW410004,
    meta: {
      title: "退職手当金受領者の変更手続き（機構へ連絡）",
    },
  },
  {
    name: "施設転換後非加入　新規登録",
    path: "/SCRW050006",
    component: SCRW050006,
    meta: {
      title: "施設転換後非加入　新規登録",
      contextName: "job_21,searchForHome",
    },
  },
  {
    name: "非加入の取下げ登録",
    path: "/SCRW050007",
    component: SCRW050007,
    meta: {
      title: "非加入の取下げ登録",
    },
  },
  {
    name: "契約解除（経営者でなくなった）入力内容確認",
    path: "/SCRW050001",
    component: SCRW050001,
    meta: {
      title: "契約解除（経営者でなくなった）入力内容確認",
      contextName: "job_02,searchForHome",
    },
  },
  {
    name: "契約解除（中退共済契約締結）入力内容確認",
    path: "/SCRW050003",
    component: SCRW050003,
    meta: {
      title: "契約解除（中退共済契約締結）入力内容確認",
      contextName: "job_03,searchForHome",
    },
  },
  {
    name: "部分解除　入力内容確認",
    path: "/SCRW050009",
    component: SCRW050009,
    meta: {
      title: "部分解除　入力内容確認",
      contextName: "job_16,searchForHome",
    },
  },
  {
    name: "施設情報の変更登録",
    path: "/SCRW050004",
    component: SCRW050004,
    meta: {
      title: "施設情報の変更登録",
      contextName: "job_17,job_19,searchForHome",
    },
  },
  {
    name: "退職手当金の請求手続き（登録内容の確認）",
    path: "/SCRW410001",
    component: SCRW410001,
    meta: {
      title: "退職手当金の請求手続き（登録内容の確認）",
      contextName:
        "job_35,job_114,groupApply,searchForHome,searchForRetirement",
    },
  },
  {
    name: "合算制度利用申出の手続き（機構への提出確認）",
    path: "/SCRW410002",
    component: SCRW410002,
    meta: {
      title: "合算制度利用申出の手続き（機構への提出確認）",
      contextName: "job_36,searchForHome",
    },
  },
  {
    name: "共済契約対象（外）施設等異動　対象者一覧",
    path: "/SCRW060003",
    component: SCRW060003,
    meta: {
      title: "共済契約対象（外）施設等異動　対象者一覧",
      contextName: "job_28,job_29,searchForHome",
    },
  },
  {
    name: "退職情報　登録（登録内容の確認）",
    path: "/SCRW060005",
    component: SCRW060005,
    meta: {
      title: "退職情報　登録（登録内容の確認）",
      contextName: "job_33,searchForHome,searchForRetirement",
    },
  },
  {
    name: "退職情報　登録（登録内容の確認）",
    path: "/SCRW060004",
    component: SCRW060004,
    meta: {
      title: "退職情報　登録（登録内容の確認）",
      contextName:
        "job_32,job_35,job_114,groupApply,searchForHome,searchForRetirement",
    },
  },
  {
    name: " 従業状況更新",
    path: "/SCRW060101",
    component: SCRW060101,
    meta: {
      title: " 従業状況更新",
      contextName: "job_01,employeeStatusUpdate,searchForHome",
    },
  },
  {
    name: "退職手当金支給予定額の証明依頼書",
    path: "/SCRW060102",
    component: SCRW060102,
    meta: {
      title: "退職手当金支給予定額の証明依頼書",
      contextName: "job_47,searchForHome",
    },
  },
  {
    name: "廃止・休止・経営移管施設内容確認",
    path: "/SCRW050008",
    component: SCRW050008,
    meta: {
      title: "廃止・休止・経営移管施設内容確認",
      contextName: "job_18,searchForHome",
    },
  },
  {
    name: "退職手当金受領者の変更手続き（登録内容の確認）",
    path: "/SCRW410005",
    component: SCRW410005,
    meta: {
      title: "退職手当金受領者の変更手続き（登録内容の確認）",
      contextName: "job_41,searchForHome",
    },
  },
  {
    name: "検索該当一覧",
    path: "/SCRW120002",
    component: SCRW120002,
    meta: {
      title: "検索該当一覧",
      contextName: "job_114,searchForHome",
    },
  },
  {
    name: "申請情報詳細（新規契約）",
    path: "/SCRW070001",
    component: SCRW070001,
    meta: {
      title: "申請情報詳細（新規契約）",
      contextName: "job_01,searchForHome",
    },
  },
  {
    name: "申請情報詳細（職員情報）一覧",
    path: "/SCRW070002",
    component: SCRW070002,
    meta: {
      title: "申請情報詳細（職員情報）一覧",
      contextName: "job_01,job_15,groupApply,searchForHome",
    },
  },
  {
    name: "申請情報詳細（新設届）",
    path: "/SCRW070003",
    component: SCRW070003,
    meta: {
      title: "申請情報詳細（新設届）",
      contextName: "job_15,groupApply,searchForHome",
    },
  },
  {
    name: "掛金確定後の職員情報の訂正",
    path: "/SCRW070005",
    component: SCRW070005,
    meta: {
      title: "掛金確定後の職員情報の訂正",
      contextName: "job_49,searchForHome",
    },
  },
  {
    name: "アカウント情報更新",
    path: "/SCRW100005",
    component: SCRW100005,
    meta: {
      title: "アカウント情報更新",
      contextName: "job_101",
    },
  },
  {
    name: "要処理一覧　担当者変更確認",
    path: "/SCRW110002",
    component: SCRW110002,
    meta: {
      title: "要処理一覧　担当者変更確認",
    },
  },
  {
    name: "原簿閲覧請求",
    path: "/SCRW070012",
    component: SCRW070012,
    meta: {
      title: "原簿閲覧請求",
    },
  },
  {
    name: "契約解除（経営者でなくなった）入力内容確認",
    path: "/SCRW050001",
    component: SCRW050001,
    meta: {
      title: "契約解除（経営者でなくなった）入力内容確認",
      contextName: "job_02",
    },
  },
  {
    name: "ヘルプ",
    path: "/SCRW020001",
    component: SCRW020001,
    meta: {
      title: "ヘルプ",
    },
  },
  {
    name: "退職手当金追加支給時等 職員情報修正",
    path: "/SCRW070004",
    component: SCRW070004,
    meta: {
      title: "退職手当金追加支給時等 職員情報修正",
      contextName: "job_114,groupApply,searchForHome",
    },
  },
  {
    name: "ID・権限一覧",
    path: "/SCRW100003",
    component: SCRW100003,
    meta: {
      title: "ID・権限一覧",
    },
  },
  {
    name: "契約解除（共済法令違反）内容入力",
    path: "/SCRW070007",
    component: SCRW070007,
    meta: {
      title: "契約解除（共済法令違反）内容入力",
      contextName: "job_09,searchForHome,searchForUnprocessed",
    },
  },
  {
    name: "契約者基本情報　更新",
    path: "/SCRW040001",
    component: SCRW040001,
    meta: {
      title: "契約者基本情報　更新",
    },
  },
  {
    name: "契約解除（加入者全員の合意）入力内容確認",
    path: "/SCRW050002",
    component: SCRW050002,
    meta: {
      title: "契約解除（加入者全員の合意）入力内容確認",
      contextName: "job_04,searchForHome",
    },
  },
  {
    name: "新規振込先金融機関登録",
    path: "/SCRW160007",
    component: SCRW160007,
    meta: {
      title: "新規振込先金融機関登録",
      contextName: "job_14,groupApply,searchForHome,paymentManagement",
    },
  },
  {
    name: "契約者アカウント詳細・更新",
    path: "/SCRW100002",
    component: SCRW100002,
    meta: {
      title: "契約者アカウント詳細・更新",
      contextName: "job_100",
    },
  },
  {
    name: "稟議・決裁対象一覧",
    path: "/SCRW110006",
    component: SCRW110006,
    meta: {
      title: "稟議・決裁対象一覧",
      contextName: "job_67,job_68,groupApply,searchForHome",
    },
  },
  {
    name: "紙法人の掛金納付対象職員届の登録",
    path: "/SCRW110004",
    component: SCRW110004,
    meta: {
      title: "紙法人の掛金納付対象職員届の登録",
    },
  },
  {
    name: "新規請求",
    path: "/SCRW160004",
    component: SCRW160004,
    meta: {
      title: "新規請求",
      contextName: "paymentManagement,searchForHome",
    },
  },
  {
    name: "請求詳細",
    path: "/SCRW160005",
    component: SCRW160005,
    meta: {
      title: "請求詳細",
      contextName: "job_13,job_83,paymentManagement,searchForHome",
    },
  },
  {
    name: "掛金情報確認 施設一覧",
    path: "/SCRC080006",
    component: SCRC080006,
    meta: {
      title: "掛金情報確認 施設一覧",
      contextName: "job_01,job_11",
    },
  },
  {
    name: "割増金請求",
    path: "/SCRW160011",
    component: SCRW160011,
    meta: {
      title: "割増金請求",
      contextName: "job_13,searchForHome",
    },
  },
  {
    name: "入金・請求データ　仕分け処理",
    path: "/SCRW160002",
    component: SCRW160002,
    meta: {
      title: "入金・請求データ　仕分け処理",
      contextName: "paymentManagement,searchForHome,job_13",
    },
  },
  {
    name: "請求者確認",
    path: "/SCRW070010",
    component: SCRW070010,
    meta: {
      title: "請求者確認",
      contextName: "notice,searchForHome",
    },
  },
  {
    name: "加入登録手続き",
    path: "/SCRW070011",
    component: SCRW070011,
    meta: {
      title: "加入登録手続き",
      contextName: "job_23,searchForHome",
    },
  },
  {
    name: "パスワード変更",
    path: "/SCRC010003",
    component: SCRC010003,
    meta: {
      title: "パスワード変更",
      isMenuContent: true,
      sideBarContentTitle: sideBarTitle.Others,
    },
  },
  {
    name: "登録メールアドレスの変更届",
    path: "/SCRW010001",
    component: SCRW010001,
    meta: {
      title: "登録メールアドレスの変更届",
      contextName: "job_76",
    },
  },
];

export { routes };
